import type {
    BaseColumnCategory,
    ColumnCategoryConfig,
} from "app/pages/sales-intelligence/common-components/column-picker";
import type { AppColumnCategory } from "app/pages/sales-intelligence/store/find-apps/types/dto";

export const COLUMN_CATEGORIES: readonly ColumnCategoryConfig<AppColumnCategory | BaseColumnCategory>[] = [
    {
        labelKey: "si.find_apps.column-picker.category.all",
        name: "all",
    },
    {
        labelKey: "si.find_apps.column-picker.category.app",
        name: "app",
    },
    {
        labelKey: "si.find_apps.column-picker.category.sdk",
        name: "sdk",
    },
];
